/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  ListOccupations200AllOf
} from './schema'



/**
 * Get a list of Occupations
 * @summary Get Occupations
 */
export const listOccupations = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ListOccupations200AllOf>> => {
    return axios.get(
      `/occupations`,options
    );
  }


export const getListOccupationsQueryKey = () => [`/occupations`];

    
export type ListOccupationsQueryResult = NonNullable<Awaited<ReturnType<typeof listOccupations>>>
export type ListOccupationsQueryError = AxiosError<unknown>

export const useListOccupations = <TData = Awaited<ReturnType<typeof listOccupations>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOccupations>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOccupationsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listOccupations>>> = ({ signal }) => listOccupations({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof listOccupations>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

